'use strict';

const i18n = require('i18next');
const _ = require('underscore');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const ViewerListViewTemplate = require('balus/ui/template/viewer/list.hbs');
const ViewerItemViewTemplate = require('balus/ui/template/viewer/item.hbs');

const ViewerItemView = Mn.View.extend({
    tagName: 'li',
    template: ViewerItemViewTemplate,
    events: {
        'click .viewer-icon': 'onClick'
    },

    onRender: function() {
        this.$('.viewer-icon').popover({
            animation: false,
            container: '.navbar',
            trigger: 'focus',
            template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>'
        });

        return this;
    },

    onClick: function() {
        // a tag は普通にクリックしても focus しないので
        // 明示的に focus を当ててやる。
        this.$('.viewer-icon').focus();
    }
});

const ViewerListView = Mn.CollectionView.extend({
    tagName: 'ul',
    childView: ViewerItemView,
    filter: function(child, index) {
        const limit = this.getOption('limit');
        if(!_.isUndefined(limit) && index > limit - 1) {
            return false;
        }

        const offset = this.getOption('offset');
        if(offset && index <= offset - 1) {
            return false;
        }

        return true;
    }
});

module.exports = Mn.View.extend({
    maxViewerNum: 4,
    template: ViewerListViewTemplate,
    ui: {
        toggleOmittedButton: '.toggle-omitted-viewer',
        omitted: '.viewer-list-omitted'
    },
    events: {
        'click @ui.toggleOmittedButton': 'toggle'
    },
    regions: {
        viewers: '.viewer-list',
        omitted: '.viewer-list-omitted'
    },

    initialize: function(params) {
        this.viewers = params.viewers;
        this.collection = new Backbone.Collection();
        this._user = params.user;
        this._showOmitted = false;
        this.updateCollection();
        this.listenTo(this.viewers, 'all', this.updateCollection);

        this.listenTo(this.viewers, 'all', this.showToggle);
    },

    onRender: function() {
        this.showChildView('viewers', new ViewerListView({
            collection: this.collection,
            limit: this.getOption('maxViewerNum')
        }));
        this.showChildView('omitted', new ViewerListView({
            collection: this.collection,
            offset: this.getOption('maxViewerNum')
        }));
        this.showToggle();
    },

    updateCollection: function() {
        const user = this.getOption('user');
        this.collection.reset(this.viewers.filter(v => {
            return !(user && v.id == user.id);
        }));
    },

    showToggle: function() {
        // 省略された viewer がいれば、toggle を表示する
        const omittedLen = this.getChildView('omitted').children.length;
        if( omittedLen > 0) {
            this.ui.toggleOmittedButton.show();
            this.ui.toggleOmittedButton.find('span').html(
                i18n.t('diagram:viewer.omittedNum', {len: omittedLen}));
        } else {
            this.ui.toggleOmittedButton.hide();
            this._showOmitted = true;
            this.toggle();
        }
    },

    toggle: function() {
        if(this._showOmitted) {
            this.ui.omitted.hide();
        } else {
            this.ui.omitted.show();
        }
        this._showOmitted = ! this._showOmitted;
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/viewer/list.js